import { render, staticRenderFns } from "./waterTree.vue?vue&type=template&id=82f48f40&scoped=true&"
import script from "./waterTree.vue?vue&type=script&lang=js&"
export * from "./waterTree.vue?vue&type=script&lang=js&"
import style0 from "./waterTree.vue?vue&type=style&index=0&id=82f48f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f48f40",
  null
  
)

export default component.exports